import get from 'lodash.get';

/**
 * Resolve the currency code for a fundraiser, team or collection page.
 *
 * Pages have no currency of their own: it belongs to the organisation. Search
 * results flatten it onto the page as `currency`, the admin record nests it
 * under the top-level `organization`, and older shapes nest it under
 * `campaign.organization`.
 */
export const getPageEntityCurrency = (entity: unknown): string | undefined =>
  get(entity, 'currency') ||
  get(entity, 'organization.currency') ||
  get(entity, 'campaign.organization.currency') ||
  undefined;
